export default {
    props: {
        group: {
            type: Object,
            required: false,
        },
        parameters: {
            type: Object,
            required: true,
        },
        id: {
            type: Number,
            required: true
        },
        type: {
            type: String,
            required: true
        },
        value: {
            type: [String, Array, Object, Boolean, Number, Date],
            required: false,
        },
        // create / edit
        context: {
            type: String,
            required: false,
            default: 'create',
            validator: (value) => {
                return ['create', 'edit'].includes(value);
            }
        },
    },
}